import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { PostEditor, type PostFormValue } from "@/components/admin/PostEditor";

export const Route = createFileRoute("/admin/posts_/$id")({
  component: EditPostPage,
  head: () => ({ meta: [{ title: "Edit Post — Admin" }, { name: "robots", content: "noindex" }] }),
});

function EditPostPage() {
  const { id } = Route.useParams();

  const { data, isLoading } = useQuery({
    queryKey: ["admin", "post", id],
    queryFn: async () => {
      const { data: p, error } = await supabase
        .from("posts")
        .select("*, post_tags(tag_id)")
        .eq("id", id)
        .single();
      if (error) throw error;
      return p;
    },
  });

  if (isLoading || !data) {
    return <AdminLayout title="Edit Post"><div className="text-slate-500">Loading…</div></AdminLayout>;
  }

  const initial: PostFormValue = {
    id: data.id,
    title: data.title ?? "",
    slug: data.slug ?? "",
    excerpt: data.excerpt ?? "",
    content_html: data.content_html ?? "",
    content: data.content ?? null,
    status: data.status,
    scheduled_for: data.scheduled_for,
    published_at: data.published_at,
    featured_image: data.featured_image,
    seo_title: data.seo_title ?? "",
    seo_description: data.seo_description ?? "",
    category_id: data.category_id,
    tag_ids: (data.post_tags ?? []).map((pt) => pt.tag_id),
    is_syncing_to_google: (data as { is_syncing_to_google?: boolean }).is_syncing_to_google ?? false,
  };

  return (
    <AdminLayout title={`Edit: ${data.title || "(no title)"}`}>
      <PostEditor initial={initial} />
    </AdminLayout>
  );
}
